<script>
  import authApi from '@/api/auth'

  export default {
    render: (h) =>  h,

    mounted () {
      const { token } = this.$route.params
      const { url } = this.$route.query

      if (!token) {
        return window.location.href = '/'
      }

      authApi.removeToken()
      authApi.storeToken(token)

      window.location.href = url || '/'
    }
  }
</script>
